module.exports = __webpack_public_path__ + "media/images/flags/st-bc4caef7e7f98dee0c82430a068fe3f4.svg";